import SelectRegion from './SelectRegion';
export default SelectRegion;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/SelectRegion/index.ts